import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import NumberFormat from "react-number-format";
import CommandeAddress from "./CommandeAddress";
import CommandePayementMethode from "./CommandePayementMethode";
import toast, { Toaster } from 'react-hot-toast';

const tableStyle = {

}

const CommandeProduct = (props)=>{


    const [itemsTotPrice, setItemsTotPrice] = useState(0.0)

    useEffect(()=>{
        toast.success('Merci de sélectionner un mode de réglement', {
            style: {
                border: '1px solid #713200',
                padding: '16px',
                color: '#3b3b3b',
            },
            iconTheme: {
                primary: '#f87100',
                secondary: '#FFFAEE',
            },
        });
    }, [])


    useEffect(()=>{
            setItemsTotPrice(props.amountHT)
    }, [props.products])



    const renderItems = (item)=>{
        return (
                    <tr key={item.id}>
                         <td>
                             <span className={"font-weight-bolder"}> {item.name}</span> / <span className={"text-muted"}>( {item.price}) €</span>
                         </td>
                        <td className={"text-center"}>
                            {item.shopQuantity}
                        </td>
                         <td className={"text-right"} colSpan={2}>
                            <span className=" text-muted">
                            <NumberFormat value={item.price * item.shopQuantity} displayType={'text'}
                                          thousandSeparator={' '} decimalScale={2} suffix={'€'}/>
                            </span>
                        </td>
                    </tr>
        )
    }

    return (
       <div className={"row"}>
           <div className="col">
               <div className={"bg-secondary p-2"}>
                   <h4 className={"font-weight-bold text-light"}>
                   <span className={"badge badge-primary"}>1</span> Récapitulatif de  votre commande :
                </h4>
               </div>
               <div>
                   <table className={"table table-bordered text-dark"} style={tableStyle}>
                       <thead className={"text-center"}>
                           <tr>
                               <th>Produit / (prix unitaire)</th><th>Quantité</th><th colSpan={2}>Montant H.T.</th>
                           </tr>
                       </thead>
                           <tbody>
                           {
                               (props.products && props.products.length>0)?
                                   props.products.map((item,index)=>{
                                       return renderItems(item)
                                   })
                                   :null
                           }
                           </tbody>
                            <tbody>
                            <tr>
                                <td className={"text-right font-weight-bold"} colSpan={3}>Total H.T. : {}</td>
                                <td className={"text-right border-top font-weight-bold"}>
                                    <NumberFormat value={props.amountHT} displayType={'text'}
                                                  thousandSeparator={' '} decimalScale={2} suffix={'€'}/>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td className={"text-right"}>Total TTC. :</td>
                                <td className={"text-right border-top text-muted"}>
                                    <NumberFormat value={props.amountHT*(1.0+props.tax)} displayType={'text'}
                                                  thousandSeparator={' '} decimalScale={2} suffix={'€'}/>
                                </td>
                            </tr>
                            </tbody>
                   </table>
               </div>
               <div className="row">
                   <div className="col-12 col-md-6">
                       <CommandeAddress />
                   </div>
                   <div className="col-12 col-md-6">
                        <CommandePayementMethode total={itemsTotPrice}/>
                   </div>
               </div>

           </div>
       </div>
    )
}


const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        products: state.ShopCartReducer.products,
        amountHT: state.ShopCartReducer.amountHT,
        tax: state.ShopCartReducer.tax,

    }
}


const mapDispatchTProps = dispatch => {
    return {
        emptyCart: (e) => dispatch( {type: 'EMPTY_CART'}),
        removeFromCart: (e) => dispatch( {type: 'REMOVE_FROM_CART',  data:{product: e}}),
        addQuantityToCart: (e) => dispatch( {type: 'ADD_QUANTITY', data:{product: e}}),
        subQuantityToCart: (e) => dispatch( {type: 'SUB_QUANTITY', data:{product: e}}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(CommandeProduct);
